import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { createRouteRef } from '@backstage/core-plugin-api';
import CloudQueueIcon from '@material-ui/icons/CloudQueue';

const rootRouteRef = createRouteRef({
  id: 'galileo-iac',
});

export default createFrontendPlugin({
  pluginId: 'galileo-iac',
  extensions: [
    PageBlueprint.make({
      name: 'main',
      params: {
        path: '/galileo-iac',
        title: 'Galileo IaC',
        icon: <CloudQueueIcon />,
        routeRef: rootRouteRef,
        loader: async () => {
          const module = await import('./components/GalileoIacPage');
          return import('react').then(React => React.createElement(module.GalileoIacPage));
        },
      },
    }),
  ],
});

export { rootRouteRef };
